<template>
  <!-- CRM replica of the client Options step (profile-configurable part only).
       Base services / upsells / insurance offers come from Nezasa. When the
       insurance-confirmation box is ON, the offer list is replaced by a single
       confirmation checkbox (the profile-driven text). -->
  <div class="step-options">
    <h2 class="step-title">{{ t('checkout_options_title', 'Additional Options') }}</h2>
    <p class="step-subtitle">{{ t('checkout_options_subtitle', 'Customize your trip with optional services and insurance.') }}</p>

    <!-- Insurance offer list (Nezasa) — shown when the confirmation box is OFF -->
    <div v-if="!showInsuranceConfirm" class="option-section">
      <h3 class="option-heading">{{ t('checkout_insurances', 'Insurance') }}</h3>
      <div class="insurance-card">
        <span class="insurance-name">{{ t('checkout_preview_sample_insurance', 'Travel protection Comfort') }}</span>
        <span class="insurance-price">€ 189,00</span>
      </div>
    </div>

    <!-- Insurance confirmation checkbox (insurance_confirm box) -->
    <div v-else class="option-section">
      <h3 class="option-heading">{{ t('boomerang_insurance_heading', 'Reiseversicherung') }}</h3>
      <label class="checkbox-label">
        <span class="toggle" :style="{ '--toggle-on': brandColor }">
          <input type="checkbox" />
          <span class="toggle-slider"></span>
        </span>
        <span v-if="insuranceConfirmHtml" v-html="insuranceConfirmHtml"></span>
        <span v-else>{{ t('boomerang_insurance_confirm', 'Ich bestätige, dass ich über die Möglichkeiten einer Reiseversicherung hingewiesen wurde.') }}</span>
      </label>
    </div>

    <div class="step-actions">
      <button class="checkout-btn checkout-btn--secondary">{{ t('checkout_back', 'Back') }}</button>
      <button class="checkout-btn checkout-btn--primary" :style="{ backgroundColor: brandColor }">{{ t('checkout_next', 'Next') }}</button>
    </div>
  </div>
</template>

<script>
import previewLang from './previewLang';

export default {
  name: 'OptionsPreview',
  mixins: [previewLang],
  props: {
    texts: { type: Object, default: () => ({}) },
    rich: { type: Object, default: () => ({}) },
    lang: { type: String, default: 'de' },
    brandColor: { type: String, default: '#1a73e8' },
    boxVisibility: { type: Object, default: () => ({}) }
  },
  computed: {
    // insurance_confirm defaults OFF (matches global default / profile).
    showInsuranceConfirm() { return this.boxVisibility.insurance_confirm === true || this.boxVisibility.insurance_confirm === 1; },
    insuranceConfirmHtml() { return (this.rich && this.rich.checkout_insurance_confirm) || ''; }
  }
};
</script>

<style scoped>
.step-title { font-size: 20px; font-weight: 700; margin: 0 0 6px; }
.step-subtitle { font-size: 13px; color: #666; margin: 0 0 24px; }

.option-section { border: 1px solid #e8e8e8; border-radius: 8px; padding: 16px; margin: 0 0 20px; }
.option-heading { font-size: 15px; font-weight: 600; margin: 0 0 12px; }
.insurance-card { display: flex; justify-content: space-between; font-size: 13px; color: #444; }
.insurance-name { font-weight: 500; }

.checkbox-label { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; line-height: 1.4; }
.toggle { position: relative; display: inline-block; width: 38px; height: 22px; flex-shrink: 0; }
.toggle input { opacity: 0; width: 0; height: 0; position: absolute; }
.toggle-slider { position: absolute; inset: 0; background-color: #ccc; border-radius: 22px; }
.toggle-slider::before { content: ''; position: absolute; height: 16px; width: 16px; left: 3px; top: 3px; background-color: #fff; border-radius: 50%; box-shadow: 0 1px 3px rgba(0,0,0,0.25); }

.step-actions { margin-top: 28px; display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.checkout-btn { padding: 10px 28px; border: none; border-radius: 4px; font-size: 14px; font-weight: 600; }
.checkout-btn--primary { color: #fff; }
.checkout-btn--secondary { background: #f0f0f0; color: #333; }
.checkbox-label :deep(p) { margin: 0; display: inline; }
</style>
